
#chart-container {
  margin-top: calc(var(--spacer) * 4);
  height: 200px;

  .bb-event-rects {
    cursor: pointer;
  }

  .bb-bar {
    &._expanded_ {
      filter: brightness(1.25);
    }
  }

  .bb-ygrid {
    stroke: var(--chart-101-pressed-dividers);
  }

  .bb-axis-y {
    .domain {
      display: none;
    }

    .tick {
      font-size: var(--body-size-xsmall);
      fill: var(--chart-300-icon-buttons);
    }
  }

  .bb-axis-x {
    position: absolute;

    .domain {
      stroke: var(--chart-101-pressed-dividers);
      stroke-width: 2px;
      fill: transparent;
    }

    .tick {
      fill: var(--main-titles-inputs-600);

      text {
        transform: translateY(var(--spacer));

        tspan {
          font-family: var(--font-family-secondary);
        }
      }
    }

    .tick:hover {
      cursor: pointer;
      fill: var(--blue-layout-301-active);
    }
  }

  &[size='medium'] .bb-axis-x .tick {
    font-size: var(--body-size);
  }

  &[size='small'] .bb-axis-x .tick {
    font-size: var(--body-size-xsmall);
  }
}

:host(:not([state='is-active'])) {
  #chart-container .tick:hover {
    cursor: default;
    fill: var(--main-titles-inputs-600);
  }
}

.chart-tooltip {
  font-size: var(--body-size);
  transform: translate(-50%, -20%);
  color: var(--main-titles-inputs-600);
  background-color: var(--white-layout-303-level-2-elevation);
  box-shadow: 0px 0px 6px 0px var(--chart-050-hover);
  border-radius: calc(var(--spacer) * 0.5);
  padding: var(--spacer) calc(var(--spacer) * 1.5);
}
